import { useEffect } from 'react';

const useEscapeKey = (callback, isActive = true) => {
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        callback();
      }
    };

    if (isActive) {
      document.addEventListener('keydown', handleEscKey);
    }
    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [callback, isActive]);
};

export default useEscapeKey;
